module.exports = ".partners-logo-image {\n  height: 135px;\n  width: 135px; }\n"